import { Flex, Radio, RadioGroup, Stack, Text } from '@podiumhq/design-system';
import { useTracking } from '@podiumhq/tracking';

import {
  MONTHLY_TERM,
  YEARLY_TERM,
} from 'components/PricingPackaging/constants';
import SavingsPill from 'components/PricingPackaging/components/SavingsPill';
import { useCheckoutContext } from 'contexts/CheckoutContextProvider';

import {
  PLAN_TERM_AGREEMENT_MONTHLY,
  PLAN_TERM_AGREEMENT_YEARLY,
} from '../../constants';

const SelectPlanTermForm = ({
  onChange,
  selectedTermValue,
  ...wrapperProps
}) => {
  const { selectedPlan = {} } = useCheckoutContext();
  const { trackEvent } = useTracking();

  const { annualPrice = '', monthlyPrice = '' } = selectedPlan;
  const handleOnChange = (value) => {
    trackEvent(`selectPlanCheckout.selectPlanType.${value}Clicked`);
    onChange && onChange(value);
  };

  return (
    <RadioGroup onChange={handleOnChange} value={selectedTermValue}>
      <Stack {...wrapperProps}>
        <SelectPlanTermRadio
          mb="16px"
          price={annualPrice}
          savings={Math.abs((monthlyPrice - annualPrice) * 12)}
          subtitle={PLAN_TERM_AGREEMENT_YEARLY}
          title="Yearly"
          value={YEARLY_TERM}
        />

        <SelectPlanTermRadio
          price={monthlyPrice}
          subtitle={PLAN_TERM_AGREEMENT_MONTHLY}
          title="Monthly"
          value={MONTHLY_TERM}
        />
      </Stack>
    </RadioGroup>
  );
};

const SelectPlanTermRadio = ({
  price,
  savings,
  subtitle,
  title,
  value,
  ...props
}) => (
  <Flex id={`radio-option-${value}`} {...radioFlexWrapperStyles} {...props}>
    <Radio width="100%" value={value}>
      <Flex {...flexStyles}>
        <Flex align="center">
          <Text fontSize="md" {...blackBoldTextStyles} mr="8px">
            {title}
          </Text>

          {subtitle && (
            <Text fontSize="md" {...lightGreyTextStyles}>
              {subtitle}
            </Text>
          )}
        </Flex>

        {price && (
          <Flex align="center">
            {!!savings && <SavingsPill mr="8px" savings={savings} />}

            <Text fontSize="lg" {...blackBoldTextStyles}>
              ${price}
            </Text>

            <Text fontSize="sm" ml="3px" {...lightGreyTextStyles}>
              /mo
            </Text>
          </Flex>
        )}
      </Flex>
    </Radio>
  </Flex>
);

const blackBoldTextStyles = {
  color: 'black.base',
  fontWeight: 'medium',
};

const flexStyles = {
  align: 'center',
  justify: 'space-between',
  width: '100%',
};

const lightGreyTextStyles = {
  color: 'grey.light',
  fontWeight: 'normal',
};

const radioFlexWrapperStyles = {
  align: 'center',
  borderColor: 'grey.lightest',
  borderRadius: '12px',
  borderWidth: '1px',
  padding: '12px 24px',
  width: '100%',
  sx: {
    '.chakra-radio__label': { width: '100%' },
  },
};

export default SelectPlanTermForm;
